
import { Component, Inject, Vue, Prop } from 'vue-property-decorator'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'
import { isEmpty } from '@zero-org/utils'

import * as Common from '@/api/common'
import { AppModule } from '@/store/modules/app'
import { ChatModule } from '@/store/modules/chat'
import { MsgType, ChatType } from '@/utils/const'
import Chat from '@/utils/chat/index'
import DLog from '@/utils/log'
import Bus from '@/utils/bus'

DLog.enable(window.config.debug)

@Component
export default class ManualBtn extends Vue {
  @Prop()
  channelId!: any

  @Inject()
  messageList: any

  get chatType() {
    return ChatModule.chatType
  }

  get talkId() {
    return AppModule.talkId
  }

  get userId () {
    return AppModule.userId
  }

  chat: any = null

  agentConfig = window.config.agentConfig

  headConfig = window.config.headConfig

  mounted() {
    const wsUrl = process.env.NODE_ENV === 'development' ? 'wss://www.qdrswzkf.cn:1443/faq' : atob(this.agentConfig.wsUrl)
    this.chat = new Chat(wsUrl)
  }

  toHuman(question: string, cb: () => void) {
    if (this.chatType === ChatType.ToHuman) {
      return
    }

    this.checkTime().then(() => {
      this.init(question, cb)
    }).catch(err => {})
  }

  checkTime() {
    const promise = new Promise((resolve, reject) => {
      const current = new Date()
      if (this.isWorkDay(current) && this.isWorkTime(current)) {
        resolve(true)
      } else {
        this.messageList.push({
          uuid: uuidv4(),
          type: MsgType.HumanMsg,
          content: this.agentConfig.notWorkTimeTip
        })
        reject(false)
      }
    })

    return promise
  }

  onClick() {
    this.toHuman('转人工', () => {
      // 调用接口保存转人工成功
      Common.recordTurnToSeat({
        talkId: this.talkId,
        userId: this.userId,
        isLogin: '2',
        channelId: this.channelId,
        operationType: 2,
      }).catch(err => {
        DLog.error(err)
      })
    })
  }

  init(question: string, cb: () => void) {
    AppModule.setTip('正在连接人工客服...')
    AppModule.setSpinning(true)

    const that = this
    this.chat.init({
      question,
      listeners: {
        onOpen(res: any) {
          that.messageList.push({
            uuid: uuidv4(),
            type: MsgType.Tip,
            content: '人工客服为您服务！目前人工客服可为您提供政策咨询，办事指南。'
          })
        },
        // 转人工成功
        onSuccess(res: any) {
          AppModule.setSpinning(false)
          cb && cb()
          that.$emit('change', ChatType.ToHuman)
        },
        // 转人工失败
        onFailed(res: any) {
          AppModule.setSpinning(false)
          that.messageList.push({
            uuid: uuidv4(),
            type: MsgType.HumanMsg,
            content: res.content
          })
          that.$emit('change', ChatType.ToRobot)
        },
        // 系统消息
        onSystemMsg(res: any) {
          const {content, fromName} = res
          if (isEmpty(content)) {
            return
          }

          if (fromName === '系统消息') {
            that.messageList.push({
              uuid: uuidv4(),
              type: MsgType.Tip,
              content
            })
          } else {
            that.messageList.push({
              uuid: uuidv4(),
              type: MsgType.HumanMsg,
              content
            })
          }
        },
        // 收到文本消息
        onTextMsg(res: any) {
          const content = res.content
          if (!isEmpty(content)) {
            that.messageList.push({
              uuid: uuidv4(),
              type: MsgType.HumanMsg,
              content
            })
          }
        },
        // 收到图片消息
        onImageMsg(res: any) {
          const imgUrl = res.content
          that.messageList.push({
            uuid: uuidv4(),
            type: MsgType.HumanImg,
            content: imgUrl
          })
        },
        // 满意度评价
        onSatisfaction(res: any) {
          Bus.$emit('onSatisfaction', res)
        },
        onQueued(res: any) {
          const content = res.content + ',您也可拨打我局服务热线12333或<a href="http://hrss.qingdao.gov.cn/fwdh.shtml" style="color:red;" target="_blank">相关业务部门电话</a>进行咨询'
          if (!isEmpty(content)) {
            that.messageList.push({
              uuid: uuidv4(),
              type: MsgType.HumanMsg,
              content
            })
          }
        },
        // 会话结束
        onReleased(res: any) {
          if (res) {
            that.messageList.push({
              uuid: uuidv4(),
              type: MsgType.HumanMsg,
              content: res.content
            })
          }
          that.$emit('change', ChatType.ToRobot)
        },
        onClose() {
          window.location.reload()
        }
      }
    })
  }

  sendText(text: string) {
    this.chat && this.chat.sendTextMsg(text)
  }

  sendImage(base64: string) {
    this.chat && this.chat.sendImageMsg(base64)
  }
  
  sendSatisfy(obj: any, cb: any) {
    this.chat && this.chat.sendSatisfy(obj, cb)
  }

  timeInRange(timeRange: string, time: any) {
    const date = time.format('YYYY-MM-DD')
    const array = timeRange.split('-').map(obj => {
      return obj.trim()
    })
    const beforeTime = `${date} ${array[0]}` 
    const isAfter = time.isAfter(beforeTime)

    const afterTime = `${date} ${array[1]}`
    const isBefore = time.isBefore(afterTime)
    return isBefore && isAfter
  }

  /**
   * 判断是否是工作时间段
   * @param currentTime 
   */
  isWorkTime(currentTime: Date) {
    const time = moment(currentTime)
    let workTime = window.config.agentConfig.workTime
    if (isEmpty(workTime)) {
      workTime = ['09:00:00-11:30:00', '13:30:00-17:00:00']
    }

    for(let i = 0, j = workTime.length; i < j; i++) {
      if (this.timeInRange(workTime[i], time)) {
        return true
      }
    }

    return false
  }

  /**
   * 判断是否是工作日
   * @param currentTime 
   */
  isWorkDay(currentTime: Date) {
    const date = moment(currentTime).format('YYYY-MM-DD')
    const year = currentTime.getFullYear()
    // 判断是否是调整的工作日
    const workdayList = this.agentConfig.workday[year] || []
    if (workdayList.includes(date)) {
      return true
    }

    // 判断是否是周末
    if ([6, 0].includes(currentTime.getDay())) {
      return false
    }

    // 判断是否是法定休息日
    const holidayList = this.agentConfig.holiday[year] || []
    if (holidayList.includes(date)) {
      return false
    }

    return true
  }

  releaseChat() {
    this.chat && this.chat.releaseChat()
    setTimeout(() => {
      this.chat && this.chat.closeWs()
    }, 200)
  }
}
